// extracted by mini-css-extract-plugin
export default {"wrapper":"SponsorCard_wrapper__qZbvO","image":"SponsorCard_image__IDZtx","body":"SponsorCard_body__cdNp5"};